import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'trackTime' })
export class TrackTimePipe implements PipeTransform {
    transform(seconds: number): string {
        if (!Number.isFinite(seconds)) { return '00:00'; }

        const mins = Math.floor(seconds / 60);
        const secs = seconds - (mins * 60);

        return `${ mins < 10 ? '0' : ''}${ mins }:${ secs < 10 ? '0' : ''}${ secs }`;
    }
}
